var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _circle, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _circle2, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _circle3, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 900,
    viewBox: "0 0 1440 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 70.9,
    cy: 48.8331,
    r: 0.9,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 161.65,
    cy: 16.5831,
    r: 1.65,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 312.14,
    cy: 43.0731,
    r: 1.14,
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 485.335,
    cy: 44.2681,
    r: 1.335,
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 995.095,
    cy: 12.0281,
    r: 1.095,
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1112.77,
    cy: 33.7031,
    r: 1.77,
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1281.53,
    cy: 23.4631,
    r: 1.53,
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1406.94,
    cy: 13.8781,
    r: 0.945,
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 36.29,
    cy: 133.69,
    r: 1.29,
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 184.005,
    cy: 115.405,
    r: 1.005,
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 323.68,
    cy: 142.08,
    r: 1.68,
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 535.185,
    cy: 142.585,
    r: 1.185,
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 682.38,
    cy: 79.7799,
    r: 1.38,
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 761.485,
    cy: 96.8849,
    r: 1.485,
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 936.05,
    cy: 73.4499,
    r: 1.05,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1037.59,
    cy: 76.9899,
    r: 1.59,
    fill: "white"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1211.55,
    cy: 79.9449,
    r: 1.545,
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1298.04,
    cy: 66.4349,
    r: 1.035,
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.82
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 98.515,
    cy: 165.382,
    r: 1.515,
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 213.215,
    cy: 218.082,
    r: 1.215,
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 312.38,
    cy: 150.247,
    r: 1.38,
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 570.515,
    cy: 221.382,
    r: 1.515,
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 576.93,
    cy: 154.797,
    r: 0.93,
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 836.99,
    cy: 175.857,
    r: 0.99,
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 872.59,
    cy: 181.457,
    r: 1.59,
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1145.59,
    cy: 198.457,
    r: 1.59,
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1264.8,
    cy: 153.667,
    r: 1.8,
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1313.19,
    cy: 161.052,
    r: 1.185,
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.82
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 98.945,
    cy: 313.279,
    r: 0.945,
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 246.29,
    cy: 238.623,
    r: 1.29,
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 392.44,
    cy: 296.773,
    r: 1.44,
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 510.665,
    cy: 253.998,
    r: 1.665,
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 702.455,
    cy: 257.788,
    r: 1.455,
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 838.44,
    cy: 310.773,
    r: 1.44,
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 959.005,
    cy: 310.339,
    r: 1.005,
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1043.09,
    cy: 299.428,
    r: 1.095,
    fill: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1159.14,
    cy: 305.474,
    r: 1.14,
    fill: "white"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.91
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1432.16,
    cy: 276.488,
    r: 1.155,
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 121.9,
    cy: 326.7,
    r: 0.9,
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 184.155,
    cy: 366.955,
    r: 1.155,
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 395.35,
    cy: 381.15,
    r: 1.35,
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.73
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 453.455,
    cy: 357.255,
    r: 1.455,
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 618.38,
    cy: 348.18,
    r: 1.38,
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 845.96,
    cy: 375.76,
    r: 0.96,
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 951.2,
    cy: 387,
    r: 1.2,
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1022.02,
    cy: 346.82,
    r: 1.02,
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1191.5,
    cy: 380.3,
    r: 1.5,
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1318.9,
    cy: 337.7,
    r: 0.9,
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 45.335,
    cy: 482.602,
    r: 1.335,
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 170.245,
    cy: 422.512,
    r: 1.245,
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.91
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 430.29,
    cy: 491.557,
    r: 1.29,
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 496.185,
    cy: 425.452,
    r: 1.185,
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 680.335,
    cy: 443.602,
    r: 1.335,
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 753.11,
    cy: 485.377,
    r: 1.11,
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 962.53,
    cy: 482.797,
    r: 1.53,
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1061.99,
    cy: 443.257,
    r: 0.99,
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1166.09,
    cy: 445.362,
    r: 1.095,
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1357.24,
    cy: 465.512,
    r: 1.245,
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 81.35,
    cy: 528.083,
    r: 1.35,
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 227.785,
    cy: 556.518,
    r: 1.785,
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 386.2,
    cy: 501.933,
    r: 1.2,
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 567.29,
    cy: 498.023,
    r: 1.29,
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 679.035,
    cy: 513.768,
    r: 1.035,
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 790.365,
    cy: 504.098,
    r: 1.365,
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1005.03,
    cy: 508.768,
    r: 1.035,
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1125.96,
    cy: 540.693,
    r: 0.96,
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1169.29,
    cy: 508.023,
    r: 1.29,
    fill: "white"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1352.5,
    cy: 497.233,
    r: 1.5,
    fill: "white"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.73
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 102.62,
    cy: 647.82,
    r: 1.62,
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 225.14,
    cy: 632.34,
    r: 1.14,
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.74
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 418.41,
    cy: 587.61,
    r: 1.41,
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.82
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 514.02,
    cy: 664.22,
    r: 1.02,
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 596.305,
    cy: 601.505,
    r: 1.305,
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 830.065,
    cy: 626.265,
    r: 1.065,
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 977.44,
    cy: 589.64,
    r: 1.44,
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1013.54,
    cy: 638.745,
    r: 1.545,
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1171.21,
    cy: 581.415,
    r: 1.215,
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1356.24,
    cy: 656.445,
    r: 1.245,
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 26.095,
    cy: 672.761,
    r: 1.095,
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 199.425,
    cy: 700.091,
    r: 1.425,
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 391.365,
    cy: 691.031,
    r: 1.365,
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 563.155,
    cy: 713.822,
    r: 1.155,
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 622.975,
    cy: 729.641,
    r: 0.975,
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.91
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 817.23,
    cy: 740.896,
    r: 1.23,
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 874.305,
    cy: 738.971,
    r: 1.305,
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1113.8,
    cy: 700.466,
    r: 1.8,
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1195.36,
    cy: 734.031,
    r: 1.365,
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1355.2,
    cy: 680.867,
    r: 1.2,
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 94.26,
    cy: 835.393,
    r: 1.26,
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 211.455,
    cy: 801.588,
    r: 1.455,
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 295.59,
    cy: 787.723,
    r: 1.59,
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 517.945,
    cy: 836.078,
    r: 0.945,
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 698.515,
    cy: 757.648,
    r: 1.515,
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 838.035,
    cy: 809.168,
    r: 1.035,
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 913.74,
    cy: 836.873,
    r: 1.74,
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1046.38,
    cy: 761.513,
    r: 1.38,
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.83
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1227.16,
    cy: 772.288,
    r: 1.155,
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1399.47,
    cy: 753.603,
    r: 1.47,
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 5.065,
    cy: 864.665,
    r: 1.065,
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 269.185,
    cy: 852.785,
    r: 1.185,
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 328.365,
    cy: 895.965,
    r: 1.365,
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 561.65,
    cy: 865.25,
    r: 1.65,
    fill: "white"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 695.515,
    cy: 871.115,
    r: 1.515,
    fill: "white"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 749.335,
    cy: 900.935,
    r: 1.335,
    fill: "white"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 875.335,
    cy: 845.935,
    r: 1.335,
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1108.31,
    cy: 869.905,
    r: 1.305,
    fill: "white"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.91
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1414.06,
    cy: 878.665,
    r: 1.065,
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.c7c546c705d951a63e1b62b07f569041.svg";
export { ForwardRef as ReactComponent };